module.exports = __webpack_public_path__ + "c1e75b50d0ca70165e26094b9c04a77e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/latte-s.png
// module id = 2548
// module chunks = 0